// extracted by mini-css-extract-plugin
export var acitonButtons = "_fh-0";
export var additionalIcon = "_fh-f";
export var block = "_fh-1";
export var blockContent = "_fh-7";
export var blockDescription = "_fh-8";
export var blockIcon = "_fh-9";
export var blockTitle = "_fh-6";
export var border = "_fh-a";
export var center = "_fh-l";
export var edge = "_fh-b";
export var edgeLabel = "_fh-c";
export var edgePath = "_fh-d";
export var error = "_fh-e";
export var flowchart = "_fh-g";
export var flowchartContent = "_fh-h";
export var highlighted = "_fh-3";
export var hover = "_fh-4";
export var icon = "_fh-i";
export var left = "_fh-m";
export var navButton = "_fh-j";
export var navButtons = "_fh-k";
export var right = "_fh-n";
export var selected = "_fh-2";
export var small = "_fh-5";